import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import { createValidator, required, richTextMaxLength } from 'util/validation'

import { AvaliacaoFormModel } from './AvaliacaoForm'

export const avaliacaoValidator = (tipoAtendProf: TipoAtendimentoProfissional) =>
  createValidator<AvaliacaoFormModel>(
    tipoAtendProf === TipoAtendimentoProfissional.ATENDIMENTO_ODONTOLOGICO
      ? {
          tiposVigilancia: [required],
          necessidadeProtese: [required],
          condicoes: [required],
          texto: [richTextMaxLength(4000)],
        }
      : {
          condicoes: [required],
          texto: [richTextMaxLength(4000)],
        }
  )
